import { useNavigate, useLocation } from "react-router-dom";
import { Heart } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useCustomer, PENDING_WISH_KEY } from "@/context/CustomerContext";

export default function WishlistButton({ productId, variant = "card" }) {
  const { wishlist, toggleWishlist } = useCustomer();
  const navigate = useNavigate();
  const location = useLocation();
  const on = wishlist.includes(productId);

  async function click(e) {
    e.preventDefault();
    e.stopPropagation();
    const r = await toggleWishlist(productId);
    if (r.needLogin) {
      try { sessionStorage.setItem(PENDING_WISH_KEY, productId); } catch { /* private mode */ }
      toast.message("Sign in to save favourites", { description: "We'll save this one as soon as you're signed in." });
      return navigate(`/account/login?next=${encodeURIComponent(location.pathname + location.search)}`);
    }
    if (!r.ok) return toast.error(r.error);
    toast.success(r.added ? "Saved to your wishlist" : "Removed from your wishlist",
      r.added ? { description: "Pick sizes to watch in My account → Wishlist." } : undefined);
  }

  const card = variant === "card";
  return (
    <button type="button" onClick={click} data-testid={`wishlist-btn-${productId}`} aria-pressed={on}
      aria-label={on ? "Remove from wishlist" : "Save to wishlist"}
      className={card
        ? "absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 backdrop-blur-md flex items-center justify-center shadow-sm hover:scale-110 active:scale-95 transition-transform"
        : "h-12 px-4 rounded-sm border border-border hover:border-[#C84A31] flex items-center justify-center gap-2 text-sm transition-colors"}>
      <Heart size={card ? 18 : 20} weight={on ? "fill" : "regular"} className={on ? "text-[#C84A31]" : "text-[#1C211E]/70"} />
      {!card && <span>{on ? "Saved" : "Save"}</span>}
    </button>
  );
}
